import { useMemo } from 'react'
import { Box, BoxProps, Styled } from 'theme-ui'
import { Cell, Column, useTable } from 'react-table'
import { noop } from 'utils'
import { SortingIcon } from 'components/Icon'
import { TableCell } from './'
import { ListTypes } from 'pages/Dashboard'

export type TableProps = BoxProps & {
  columns?: Column<{}>[]
  sorting?: string
  data: {}[]
  onRowClick?: (id: string) => void
  activeList?: ListTypes | string
}

export function Table({
  data,
  sorting,
  columns = [],
  onRowClick = noop,
  activeList = 'student',
}: TableProps) {
  const d = useMemo(() => data, [data])
  const cols = useMemo(() => columns, [columns])
  const table = useTable({
    data: d,
    columns: cols,
  })
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    table

  function handleRowClick({ id }: any) {
    onRowClick(id)
  }

  return (
    <Box
      as="table"
      variant="styles.table"
      aria-label={
        activeList === 'tmatt'
          ? 'Teachers'
          : activeList === 'refresher'
          ? 'Refresher'
          : 'Students'
      }
      {...getTableProps()}>
      {data.length > 0 && (
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => {
                return (
                  <th {...column.getHeaderProps(column.getHeaderProps())}>
                    <span>{column.render('Header')}</span>
                    {sorting === column.id && (
                      <SortingIcon sx={{ ml: 2, display: 'inline-block' }} />
                    )}
                  </th>
                )
              })}
            </tr>
          ))}
        </thead>
      )}

      <tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row)
          return (
            // eslint-disable-next-line
            <Styled.tr
              onClick={() => handleRowClick(row.original)}
              {...row.getRowProps()}
              key={(row.original as any).id}>
              {row.cells.map((cell: Cell) => (
                <TableCell
                  key={cell.column.id}
                  {...cell}
                  activeList={activeList}
                />
              ))}
            </Styled.tr>
          )
        })}
      </tbody>
    </Box>
  )
}
